type Tone = { frequency: number; start: number; duration: number }

function playTones(tones: Tone[]) {
  try {
    const ctx = new AudioContext()

    tones.forEach(({ frequency, start, duration }) => {
      const oscillator = ctx.createOscillator()
      const gain = ctx.createGain()

      oscillator.type = 'triangle'
      oscillator.frequency.value = frequency

      const startTime = ctx.currentTime + start
      gain.gain.setValueAtTime(0.4, startTime)
      gain.gain.exponentialRampToValueAtTime(0.01, startTime + duration)

      oscillator.connect(gain)
      gain.connect(ctx.destination)

      oscillator.start(startTime)
      oscillator.stop(startTime + duration)
    })
  } catch {
    console.error('Web Audio API is not supported in this browser')
  }
}

export function playDialOutTone() {
  playTones([
    { frequency: 880, start: 0, duration: 0.1 },
    { frequency: 1175, start: 0.12, duration: 0.1 },
    { frequency: 1397, start: 0.24, duration: 0.15 },
  ])
}

export function playDialOutDisconnectTone() {
  playTones([
    { frequency: 1397, start: 0, duration: 0.1 },
    { frequency: 1175, start: 0.12, duration: 0.1 },
    { frequency: 880, start: 0.24, duration: 0.15 },
  ])
}
